var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FormHelperText } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import NativeSelect from '@material-ui/core/NativeSelect';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ExpandMore from '@material-ui/icons/ExpandMore';
import React from 'react';
import { BootstrapInput } from 'react-components/BootstrapInput';
import { isCapitalUI } from 'react-common/theme';
const useIconStyles = makeStyles((theme) => ({
    root: {
        marginTop: 2,
        marginRight: 5,
        color: theme.palette.primary.main
    }
}));
const iconComponent = (props) => {
    const classes = useIconStyles();
    return React.createElement(ExpandMore, Object.assign({}, Object.assign(Object.assign({}, props), { className: `${props.className} ${classes.root}` })));
};
let nextSelectId = 0;
export default React.forwardRef((props, ref) => {
    var _a, _b, _c, _d, _e;
    const [capitalId] = React.useState(() => `capital-select-${++nextSelectId}`);
    if (isCapitalUI) {
        const { label, fullWidth, error, errorText, labelClassName, formControlProps, formControlClassName, size } = props, selectProps = __rest(props, ["label", "fullWidth", "error", "errorText", "labelClassName", "formControlProps", "formControlClassName", "size"]);
        const id = props.id || ((_a = props.inputProps) === null || _a === void 0 ? void 0 : _a.id) || capitalId;
        const helpId = `${id}-helper`;
        const describedBy = [(_b = props.inputProps) === null || _b === void 0 ? void 0 : _b['aria-describedby'], error && errorText ? helpId : null].filter(Boolean).join(' ') || undefined;
        return (React.createElement(FormControl, Object.assign({ ref: ref, variant: "filled", size: size, fullWidth: fullWidth, error: error, disabled: props.disabled, required: props.required, className: formControlClassName }, (formControlProps || {})),
            React.createElement(InputLabel, { htmlFor: id, variant: "filled", className: labelClassName, shrink: true }, label),
            React.createElement(NativeSelect, Object.assign({}, selectProps, { id: id, variant: "filled", input: React.createElement(BootstrapInput, null), inputProps: Object.assign(Object.assign({}, props.inputProps), { 'aria-describedby': describedBy }) })),
            error && errorText && React.createElement(FormHelperText, { id: helpId, error: true }, errorText)));
    }
    const { label, fullWidth, error, labelClassName, formControlProps } = props, selectProps = __rest(props, ["label", "fullWidth", "error", "labelClassName", "formControlProps"]);
    return (React.createElement(FormControl, Object.assign({ ref: ref, variant: (_c = props.variant) !== null && _c !== void 0 ? _c : 'filled', size: props.size, fullWidth: fullWidth, error: error, className: props.formControlClassName }, (formControlProps || {})),
        React.createElement(InputLabel, { variant: (_d = props.variant) !== null && _d !== void 0 ? _d : 'filled', className: labelClassName, shrink: !!props.value }, label),
        React.createElement(NativeSelect, Object.assign({ input: React.createElement(BootstrapInput, null), variant: (_e = props.variant) !== null && _e !== void 0 ? _e : 'filled' }, selectProps)),
        React.createElement(FormHelperText, { error: error, style: { display: error ? 'unset' : 'none' } }, props.errorText)));
});
